import SelfServiceReport from "./interfaces/SelfServiceReport";
import SelfServiceReportDto from "./interfaces/dtos/SelfServiceReportDto";
import ColumnInfoDto, { DataType } from "./interfaces/dtos/ColumnInfoDto";
import ColumnInfo, { Filter } from "./interfaces/ColumnInfo";
import ReportData from "./interfaces/ReportData";
import ReportDataDto from "./interfaces/dtos/ReportDataDto";
import { parseDataSource, selectStoredDataState } from "./utils";
import Field from "./interfaces/Field";
import FieldDto from "./interfaces/dtos/FieldDto";
import FieldGroup from "./interfaces/FieldGroup";
import FieldGroupDto from "./interfaces/dtos/FieldGroupDto";

export const mapSelfServiceReportDtoToModel = (
  reportDto: SelfServiceReportDto
): SelfServiceReport => {
  let tableSettings;

  try {
    tableSettings = JSON.parse(reportDto.tableSettings);
  } catch {}

  tableSettings = tableSettings ?? {};

  return {
    ...reportDto,
    tableSettings,
  };
};

export const mapSelfServiceReportModelToDto = (
  report: SelfServiceReport
): SelfServiceReportDto => {
  const tableSettings = JSON.stringify({
    dataState: selectStoredDataState(report.tableSettings.dataState),
  });

  return {
    ...report,
    tableSettings,
  };
};

export const mapDataTypeToFilter = (dataType: DataType): Filter => {
  switch (dataType) {
    case "Boolean":
      return "boolean";
    case "Date":
    case "DateTime":
      return "date";
    case "Decimal":
    case "Integer":
      return "numeric";
    case "String":
      return "text";
    default:
      return undefined;
  }
};

export const mapColumnInfoDtoToModel = (
  columnInfoDto: ColumnInfoDto
): ColumnInfo => {
  return {
    title: columnInfoDto.title,
    field: columnInfoDto.field,
    filter: mapDataTypeToFilter(columnInfoDto.dataType),
    format: columnInfoDto.gridFormat ?? undefined,
    exportFormat: columnInfoDto.exportFormat ?? undefined,
    width: columnInfoDto.width,
  };
};

export const mapSelfServiceReportDataDtoToModel = (
  reportDataDto: ReportDataDto
): ReportData => {
  const columns = reportDataDto.columns.map(mapColumnInfoDtoToModel);
  const dataSource = parseDataSource(
    reportDataDto.dataSource,
    reportDataDto.columns
  );

  return { columns, dataSource };
};

export const mapFieldDtoToModel = (fieldDto: FieldDto): Field => ({
  fieldId: fieldDto.fieldId,
  displayName: fieldDto.displayName,
  dataSourceName: fieldDto.dataSourceName,
});

export const mapFieldGroupDtoToModel = (
  fieldGroupDto: FieldGroupDto
): FieldGroup => ({
  ...fieldGroupDto,
  fields: fieldGroupDto.fields.map(mapFieldDtoToModel),
});
